import { useSelector } from "react-redux";
import Timer from "../../../../../Common/Timer";
import { Link } from "react-router-dom";

const DynoStartTest = ({ stopTest, startTest }) => {
  const eol = useSelector((state) => state.eolTests);
  const dynoStartDetails = eol?.dynoStartDetails;
  const dynoTestRunningStatus = eol?.dynoTestRunningStatus;

  return (
    <>
      <Timer
        loading={dynoTestRunningStatus}
        timeDiff={(Date.now() - dynoStartDetails?.startTime) / 1000}
        stop={stopTest}
        stopIntervel={30}
      />
      {dynoTestRunningStatus ? (
        <Link className="stop" onClick={stopTest}>
          Stop Test
        </Link>
      ) : (
        <Link className="start" onClick={startTest}>
          Start Test
        </Link>
      )}
    </>
  );
};

export default DynoStartTest;
